import { categoryConverter } from 'api/converters/CategoryConverter';
import { collection, getDocs } from 'firebase/firestore';
import { ICategory } from 'types';
import { db } from '../lib/firebase';

/**
 * Fetch all category documents from Firestore
 *
 * Retrieves all ICategory documents from the `categories` collection. Uses the category converter
 * to ensure proper deserialization. Returns an empty array if no categories exist.
 *
 * @return {Promise<ICategory[]>} Array of all ICategory documents in the collection
 */
export const fetchCategories = async (): Promise<ICategory[]> => {
  const collectionName = 'categories';
  const collectionData = collection(db, collectionName).withConverter(categoryConverter);
  const snapshot = await getDocs(collectionData);
  const categories: ICategory[] = [];

  snapshot.forEach((doc) => {
    categories.push(doc.data());
  });

  return categories;
};
